module.exports = __webpack_public_path__ + "static/img/online.f01047be.png";